<template>
  <div class="headingbasicdetailsrules">
    <p class="notification"><span class="has-text-weight-bold">For advanced users only.</span> Custom rules allow you to build advanced rule logic. Please contact your account manager if you would like assistance creating custom rules.</p>

    <div>
      <span class="is-size-4">Air Rules</span>
      <a style="float: right" @click="customRule('air', 'new')">
        <u>+ Add Rule</u>
      </a>
      <br />
      <div>
        <div
          class="heading-travel-policy"
          v-for="(item, index) in obj.rules.filter(
            (rule) => rule.category === 'air'
          )"
          :key="item.uid ? item.uid : item.id"
          :index="index"
        >
          <span :class="item.status == 'active' ? 'tag is-success' : 'tag'"
            >Custom rule</span
          >

          <div class="right-content">
            <div class="lefttext">
              <p>
                <span v-html="ruleMessage(item)"> </span
                ><span
                  class="rule-config-variable"
                  @click="customRule(item.category, 'edit', item)"
                >
                  <b-icon icon="pencil" size="is-small"></b-icon>
                </span>
              </p>
            </div>
            <div class="allbtns" v-if="item.id">
              <b-switch
                :rounded="true"
                true-value="active"
                false-value="inactive"
                v-model="item.status"
              >
              </b-switch>
            </div>
            <div class="allbtns" v-else>
              <a @click="remove(item)"> Delete </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div>
      <span class="is-size-4">Car Rules</span>
      <a style="float: right" @click="customRule('car', 'new')">
        <u>+ Add Rule</u>
      </a>
      <div> 
        <div
          class="heading-travel-policy"
          v-for="(item, index) in obj.rules.filter(
            (rule) => rule.category === 'car'
          )"
          :key="item.uid ? item.uid : item.id"
          :index="index"
        >
          <span :class="item.status == 'active' ? 'tag is-success' : 'tag'"
            >Custom rule</span
          >

          <div class="right-content">
            <div class="lefttext">
              <p>
                <span v-html="ruleMessage(item)"> </span
                ><span
                  class="rule-config-variable"
                  @click="customRule(item.category, 'edit', item)"
                >
                  <b-icon icon="pencil" size="is-small"></b-icon>
                </span>
              </p>
            </div>
            <div class="allbtns" v-if="item.id">
              <b-switch
                :rounded="true"
                true-value="active"
                false-value="inactive"
                v-model="item.status"
              >
              </b-switch>
            </div>
            <div class="allbtns" v-else>
              <a @click="remove(item)"> Delete </a>
            </div>
          </div>
        </div>
      </div>
      </div>
      
   
    <hr />
    <div>
      <span class="is-size-4">Hotel Rules</span>
      <a style="float: right" @click="customRule('hotel', 'new')">
        <u>+ Add Rule</u>
      </a>
      <div
          class="heading-travel-policy"
          v-for="(item, index) in obj.rules.filter(
            (rule) => rule.category === 'hotel'
          )"
          :key="item.uid ? item.uid : item.id"
          :index="index"
        >
          <span :class="item.status == 'active' ? 'tag is-success' : 'tag'"
            >Custom rule</span
          >

          <div class="right-content">
            <div class="lefttext">
              <p>
                <span v-html="ruleMessage(item)"> </span
                ><span
                  class="rule-config-variable"
                  @click="customRule(item.category, 'edit', item)"
                >
                  <b-icon icon="pencil" size="is-small"></b-icon>
                </span>
              </p>
            </div>
            <div class="allbtns" v-if="item.id">
              <b-switch
                :rounded="true"
                true-value="active"
                false-value="inactive"
                v-model="item.status"
              >
              </b-switch>
            </div>
            <div class="allbtns" v-else>
              <a @click="remove(item)"> Delete </a>
            </div>
          </div>
        </div>
      </div>
      <br>
   
  </div>
</template>
<script>
import { tupleExpression } from "@babel/types";
import CustomRuleModal from "./CustomRuleModal.vue";

export default {
  name: "CustomRules",
  props: {
    travelPolicy: {
      type: [Object],
    },
  },
  data() {
    return {
      obj: {
        rules: [],
      }
    };
  },
  watch: {
    travelPolicy: {
      handler(newVal, prevVal) {
        this.obj.rules=newVal.rules;
        this.$emit("rules", this.obj);

     
      },
      deep: true,
    }
      
},
  methods: {
    customRule(type, mode, rule = null) {
      this.$buefy.modal.open({
        parent: this,
        component: CustomRuleModal,
        width: 1400,
        hasModalCard: true,
        customClass: "",
        trapFocus: true,
        props: {
          travelPolicy: this.travelPolicy,
          type: type,
          mode: mode,
          rules: rule
            ? rule
            : {
                travelPolicyId: "",
                id: "",
                uid: "Rule" + Math.random() + new Date().getTime(),
                category: type,
                name: "",
                code: "",
                status: "",
                approvalLevel: "",
                visibility: "",
                triggerWhen: "",
                approvalRequired: "",
                defaultApprovalAction: "",
                actionType: "",
                actionsJson:'{}',
                conditions: [],
                actions: [],
              },
        },
        events: {
          save: (rule) => {
            console.log(rule);
            this.getCustomRules(rule);
          },
        },
      });
    },

    updateRules(val) {
      var index;
      if (val.id) index = this.obj.rules.findIndex((f) => f.id === val.id);
      else index = this.obj.rules.findIndex((f) => f.uid === val.uid);

      if (index == -1) {
        this.obj.rules.push(val);
      } else {
        this.obj.rules[index] = val;
      }
      console.log(this.obj);
    },
    getCustomRules(val) {
      this.updateRules(val);
      this.$emit("rules", this.obj);
    },
    ruleMessage(rule) {
      if (rule.conditions.length > 0) {
        if (rule.conditions.length == 1) {
          return rule.conditions[0].message;
        } else {
          var triggerWhen = rule.triggerWhen == "any" ? "OR" : "AND";

          let conditionMessages = rule.conditions.map((r) => r.message);

          return conditionMessages.join(
            ' &nbsp;<span class="has-text-success has-text-weight-bold">' +
              triggerWhen +
              "</span>&nbsp;"
          );
        }
      }
      return null;
    },

    remove(val) {
      var index;
      if (val.id) index = this.obj.rules.findIndex((f) => f.id === val.id);
      else index = this.obj.rules.findIndex((f) => f.uid === val.uid);

      if (index > -1) this.obj.rules.splice(index, 1);
    },
  },
  mounted(){
      this.$emit("rules", this.obj);

    }
};
</script>
